export const environment = {
  production: false,
  apiUrl: '/api/', // Your development API URL
  apiDomain: '', // Your development domain

  // Cloudflare Turnstile site key. This is the REAL widget (managed mode), which has
  //  dev.app2.myipsat.com in its domain list, so dev exercises real Turnstile behavior
  //  rather than the always-pass test key.
  // Dev builds use --configuration=development, which does NOT fileReplace this with
  //  environment.prod.ts, so this file is what actually ships on dev.
  turnstileSiteKey: '0x4AAAAAAEHWuy5pWgJOzMVU',
};
